import { client } from '..';
import { ReligionsTypesResponse } from '../models/religionModels';

export const getReligionsTypes = async (): Promise<ReligionsTypesResponse[]> => {
  const { data } = await client.get('/religions');
  return data;
};
